import { useLocaleContext } from '@src/components/locale/locale.context'
import { prefixSchemaUrlWithLocale } from '@src/components/locale/utils'
import Directory from '@src/quince-site-common/src/domains/Directory'
import { getNonce } from '@src/utils/nonce.utils'

interface IBreadcrumbSchema {
  directory: Directory
}

export const BreadcrumbSchema: React.FC<IBreadcrumbSchema> = ({ directory }) => {
  const { locale, regionDetails } = useLocaleContext()
  const allButLastPath = directory?.paths?.slice(0, -1) ?? []
  if (allButLastPath.length === 0) return <></>
  const nonce = getNonce()

  const breadcrumbSchema = {
    '@context': 'https://schema.org/',
    // eslint-disable-next-line i18next/no-literal-string
    '@type': 'BreadcrumbList',
    itemListElement: allButLastPath.map((path, idx) => ({
      // eslint-disable-next-line i18next/no-literal-string
      '@type': 'ListItem',
      position: idx + 1,
      name: path.displayName,
      item: prefixSchemaUrlWithLocale(`https://www.quince.com${path.route}`, locale, regionDetails),
    })),
  }

  return (
    <script
      type="application/ld+json"
      nonce={nonce}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
    />
  )
}
